import { Url } from '../components/constants/appConstants';

export async function getRedirectUrl(user) {
  return Url.HOME;
}
